import React, { useEffect } from "react";
import Config from "config";

import { useSelector, useDispatch } from "react-redux";

import { DeskTopSearch, MobileSearch, TabSearch, PopUpSearch } from "./SearchHeader";
import {
  searchDataChange,
  searchIonRangeChange,
  searchListChange,
  updateIonRange,
  CheckBoxChange,
  ClearSearch,
} from "../stores/propertySlice";
import {
  gotoSearchPage,
  getApiDataAsync,
  areEqualObjValue,
  valueRangeMaxMin,
  commonSearchDataChange,
} from "./Common";
import province from "province";

const pagesLink = Config.pagesLink;
const $ = window.$;

export const HeaderNav = (props) => {
  const Body = (props) => {
    let searchBtn;
    if (false && props.searchBtn) {
      searchBtn = (
        <div className="header-right">
          {/* <img
            className="open-search"
            src="/SiteCollectionDocuments/assets/PFS2022/theme/img/icon/search.svg"
            alt="Search"
          />
          <img
            className="close-search d-none"
            src="/SiteCollectionDocuments/assets/PFS2022/theme/img/icon/close-filter.svg"
            alt="Close"
          /> */}

          <button type="button" className="open-search d-none">
            <img
              src="/SiteCollectionDocuments/assets/PFS2022/theme/img/icon/search.svg"
              alt="Search"
            />
          </button>
          <button type="button" className="close-search d-none">
            <img
              src="/SiteCollectionDocuments/assets/PFS2022/theme/img/icon/close-filter.svg"
              alt="Close"
            />
          </button>
          <button type="button" className="alert-noti">
            <i className="ic-npa ic-noti-default window-click" />
            <i className="new-msg window-click" />
          </button>
        </div>
      );
      useEffect(() => {
        $(".open-search").on("click", function () {
          $(".close-search").removeClass("d-none");
          $(".open-search").addClass("d-none");
          $("#search-wrapper").removeClass("d-none");
          $("#property-tab-search").removeClass("d-none");
          // var galleryContainerPos = document.querySelector(".gallery-container").getBoundingClientRect().bottom;
          // if (galleryContainerPos <= 0) {
          //     $("#header-placeholder").height($("#header").height());
          // }
          $("#header").addClass("fixed");
          // $("#icw").append(
          //   '<div id="backdrop" style="position: fixed; top: 0; left: 0; width: 100%; height: 100vh; background-color: rgba(0, 0, 0, 0.5); overflow: hidden; z-index: 100;"></div>'
          // );
          $("body").css({
            height: "100%",
            overflow: "hidden",
            position: "relative",
            touchAction: "none",
            "-ms-touch-action": "none",
          });
        });

        $(".close-search").on("click", function () {
          var scrollPos = $(window).scrollTop();
          $(".close-search").addClass("d-none");
          $(".open-search").removeClass("d-none");
          $("#search-wrapper").addClass("d-none");
          $("#property-tab-search").addClass("d-none");

          if (scrollPos <= 0) {
            $("#header").removeClass("fixed");
          }
          $("#more-filter-desktop").height(0);
          $("#header-placeholder").height(0);
          $(".more-filter-btn.close").css({ display: "" });
          $(".more-filter-btn.desktop").css({ display: "" });
          $("#backdrop").remove();
          $("body").css({
            height: "auto",
            overflow: "auto",
            position: "initial",
            touchAction: "auto",
            "-ms-touch-action": "auto",
          });
          $("#icw #header").css({
            height: "",
            overflow: "",
          });
        });
      }, []);
    } else {
      searchBtn = (
        <div className="header-right">
          <a href={pagesLink.search} className="open-search">
            <img src="/SiteCollectionDocuments/assets/PFS2022/theme/img/icon/search.svg" alt="Search"/>
          </a>
          {/* <button type="button" className="open-search">
            <img
              src="/SiteCollectionDocuments/assets/PFS2022/theme/img/icon/search.svg"
              alt="Search"
            />
          </button>
          <button type="button" className="close-search d-none">
            <img
              src="/SiteCollectionDocuments/assets/PFS2022/theme/img/icon/close-filter.svg"
              alt="Close"
            />
          </button> */}
          <button type="button" className="alert-noti">
            <i className="ic-npa ic-noti-default window-click" />
            <i className="new-msg window-click" />
          </button>
        </div>
      );
      // useEffect(() => {
      //   $(".open-search").on("click", function () {
      //     $(".search-section").removeClass("d-none");

      //     // $("#header-placeholder").height($("#header").height());
      //     $("#inner-header-placeholder").height(0);
      //     $("#inner-header").removeClass("fixed");
      //     $("#header").addClass("fixed");
      //     $(".open-search").addClass("d-none");
      //     $(".close-search").removeClass("d-none");

      //     // $("#icw").append(
      //     //   '<div id="backdrop" style="position: fixed; top: 0; left: 0; width: 100%; height: 100vh; background-color: rgba(0, 0, 0, 0.5); overflow: hidden; z-index: 50;"></div>'
      //     // );
      //     $("body").css({
      //       height: "100%",
      //       overflow: "hidden",
      //       position: "relative",
      //       touchAction: "none",
      //       "-ms-touch-action": "none",
      //     });
      //   });

      //   $(".close-search").on("click", function () {
      //     $(".search-section").addClass("d-none")

      //     $("#inner-header-placeholder").height($("#inner-header").height());
      //     // $("#header-placeholder").height(0);
      //     $("#inner-header").addClass("fixed");
      //     $("#header").removeClass("fixed");
      //     $(".open-search").removeClass("d-none");
      //     $(".close-search").addClass("d-none");

      //     $("#backdrop").remove();
      //     $("body").css({
      //       height: "auto",
      //       overflow: "auto",
      //       position: "initial",
      //       touchAction: "auto",
      //       "-ms-touch-action": "auto",
      //     });

      //     // Close more filter on desktop
      //     if (window.innerWidth >= 1025) {
      //       $("#icw #header").css({
      //         backgroundImage: "",
      //         // padding: 0,
      //         height: "",
      //         overflow: "hidden",
      //       });

      //       $("#more-filter-desktop").animate({ height: 0 });
      //       $(".more-filter-btn.close").css({ display: "" });
      //       $(".more-filter-btn.desktop").css({ display: "" });
      //     }
      //   });
      // }, []);
    }

    useEffect(() => {
      $('link[href*="/_catalogs/masterpage/KWeb2016/assets/css/style-en.css"]').attr('disabled', 'disabled');
    }, []);

    return (
      <>
        <div className="d-flex align-items-center header-left">
          <div className="hamburger-menu">
            <button
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#mobile-menu"
              aria-controls="mobile-menu"
              aria-label="mobile-menu"
              name="mobile-menu"
            >
              <span className="menu-line line-1"></span>
              <span className="menu-line line-2"></span>
              <span className="menu-line line-3"></span>
            </button>
          </div>
          <div className="logo-wrap">
            <a href="/th" target="_self">
              <img
                className="kbank-icon"
                src="/SiteCollectionDocuments/assets/PFS2022/theme/img/logo/logo-kasikornthai-h50.png"
                alt="Kbank"
              />
            </a>
            <div className="spacer"></div>
            <a href={pagesLink.home} target="_self">
              <img
                className="k-property-icon"
                src="/SiteCollectionDocuments/assets/PFS2022/theme/img/logo/logo-kproperty-h50.png"
                alt="K-Property"
              />
            </a>
          </div>
        </div>
        <div className="header-center">
          <ul>
            <li>
              <a href={pagesLink.search}>ค้นหาทรัพย์สิน</a>
            </li>
            <li>
              <a href={pagesLink.promotion}>โปรโมชัน</a>
            </li>
            <li>
              <a href={pagesLink.tutorial}>วิธีเสนอซื้อทรัพย์สิน</a>
            </li>
            <li>
              <a href="/th/propertyforsale/article">บทความแนะนำ </a>
            </li>
            <li>
              <a href="/th/propertyforsale/npabroker" title="ตัวแทนขาย">
                ตัวแทนขาย
              </a>
            </li>
            <li className="position-relative li-sub-menu-toggle">
              <div
                className="sub-menu-toggle"
                data-kbct="link_click"
                data-kblb="second_hand_home_loan"
                data-kbgp="navigate"
                title="สินเชื่อบ้านมือสอง"
              >
                <span>สินเชื่อบ้านมือสอง</span>
              </div>
              <ul className="sub-menu position-absolute">
                <li className="position-relative">
                  <a
                    href="https://www.kasikornbank.com/th/personal/loan/homeLoan/pages/k-smart-asset.aspx"
                    title="สินเชื่อเพื่อที่อยู่อาศัย"
                    data-kbct="link_click"
                    data-kblb="second_hand_home_loan-housing_loan"
                    data-kbgp="navigate"
                  >
                    สินเชื่อเพื่อที่อยู่อาศัย
                  </a>
                  <i className="sub-menu-arrow" />
                </li>
                <li className="position-relative">
                  <a
                    href="https://www.kasikornbank.com/th/business/sme/loan/loandesign/pages/k-sme-smart-asset.aspx"
                    title="สินเชื่อเพื่อลงทุนในสินทรัพย์ถาวร"
                    data-kbct="link_click"
                    data-kblb="second_hand_home_loan-loan_for_investment"
                    data-kbgp="navigate"
                  >
                    สินเชื่อเพื่อลงทุนในสินทรัพย์ถาวร
                  </a>
                  <i className="sub-menu-arrow" />
                </li>
              </ul>
            </li>
            {/* <li>
              <a href={pagesLink.secondHand}>สินเชื่อบ้านมือสอง</a>
            </li> */}
            <li>
              <a href={pagesLink.faq}>คำถามที่พบบ่อย</a>
            </li>
          </ul>
        </div>
        {searchBtn}
      </>
    );
  };

  useEffect(() => {
    //hamburger menu
    document.querySelectorAll("#inner-header .logo-wrap a").forEach(function (item) {
      item.addEventListener("click", function (e) {
        dataLayer.push({
          event: "track_event",
          event_category: "header",
          event_action: "click",
          event_label: e.target.alt,
        });
      });
    });

    //header menu
    document.querySelectorAll("#inner-header .header-center a").forEach(function (item) {
      item.addEventListener("click", function (e) {
        dataLayer.push({
          event: "track_event",
          event_category: "header",
          event_action: "click",
          event_label: e.target.innerText,
        });
      });
    });
  });

  if (props.wrap) {
    return (
      <div id="inner-header" className="header-inner-wrap header-top">
        <div className="header-inner">
          <Body {...props} />
        </div>
      </div>
    );
  }
  return (
    <div id="inner-header" className="header-inner header-top">
      <Body {...props} />
    </div>
  );
};

export const MobileNav = () => {
  useEffect(() => {
    //ทราบจำนวนคลิกในส่วน header
    document.querySelectorAll("#mobile-menu > div.offcanvas-body > ul").forEach(function (item) {
      item.addEventListener("click", function (e) {
        window.dataLayer.push({
          event: "track_event",
          event_category: "header",
          event_action: "click",
          event_label: e.target.innerText,
        });
      });
    });
  }, []);
  return (
    <div
      id="mobile-menu"
      className="mobile-offcanvas offcanvas offcanvas-start"
      data-bs-scroll="false"
      data-bs-backdrop="true"
      tabIndex="-1"
    >
      <div className="offcanvas-header">
        <div className="k-property-m-logo">
          <a href="/th" target="_self">
            <img
              src="/SiteCollectionDocuments/assets/PFS2022/theme/img/logo/kbank.png"
              alt="Kbank"
              className="kbank-logo"
            />
          </a>
          <div className="spacer"></div>
          <a href={pagesLink.home} target="_self">
            <img
              src="/SiteCollectionDocuments/assets/PFS2022/theme/img/logo/k-property.png"
              alt="K-Property"
              className="k-property-logo"
            />
          </a>
        </div>
        <button
          type="button"
          className="close-mobile-menu-btn"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          name="Close mobile menu"
        ></button>
      </div>
      <div className="offcanvas-body">
        <ul className="mobile-listmenu">
          <li>
            <a href={pagesLink.search}>ค้นหาทรัพย์สิน</a>
          </li>
          <li>
            <a href={pagesLink.promotion}>โปรโมชัน</a>
          </li>
          <li>
            <a href={pagesLink.tutorial}>วิธีเสนอซื้อทรัพย์สิน</a>
          </li>
          <li>
            <a href="/th/propertyforsale/article">บทความแนะนำ </a>
          </li>
          <li>
            <a href="/th/propertyforsale/npabroker" title="ตัวแทนขาย">
              ตัวแทนขาย
            </a>
          </li>
          <li>
            <div
              className="d-flex align-items-center position-relative sub-menu-toggle justify-content-between"
              title="สินเชื่อบ้านมือสอง"
              data-kbct="link_click"
              data-kblb="second_hand_home_loan"
              data-kbgp="navigate"
            >
              <span>สินเชื่อบ้านมือสอง</span>
              <i className="sub-menu-arrow" />
            </div>
            <ul className="sub-menu">
              <li>
                <a
                  href="https://www.kasikornbank.com/th/personal/loan/homeLoan/pages/home.aspx#loan-interest-npa"
                  data-kbct="link_click"
                  data-kblb="second_hand_home_loan-housing_loan"
                  data-kbgp="navigate"
                  title="สินเชื่อเพื่อที่อยู่อาศัย"
                >
                  สินเชื่อเพื่อที่อยู่อาศัย
                </a>
              </li>
              <li>
                <a
                  href="https://www.kasikornbank.com/th/business/sme/loan/loandesign/pages/k-sme-smart-asset.aspx"
                  data-kbct="link_click"
                  data-kblb="second_hand_home_loan-loan_for_investment"
                  data-kbgp="navigate"
                  title="สินเชื่อเพื่อลงทุนในสินทรัพย์ถาวร"
                >
                  สินเชื่อเพื่อลงทุนในสินทรัพย์ถาวร
                </a>
              </li>
            </ul>
          </li>
          {/* <li>
            <a href={pagesLink.secondHand}>สินเชื่อบ้านมือสอง</a>
          </li> */}
          <li>
            <a href={pagesLink.faq}>คำถามที่พบบ่อย</a>
          </li>
          <li>
            <a href="/th">
              <img
                src="/SiteCollectionDocuments/assets/PFS2022/theme/img/logo/kbank.png"
                alt="Kbank"
                style={{ height: "30px", marginRight: "10px" }}
              />{" "}
              หน้าหลัก{" "}
            </a>
          </li>
        </ul>
      </div>
      <div className="offcanvas-footer">
        <div className="nav-ft-service">
          <a href="https://www.facebook.com/KBankLive/" target="_blank" className="nav-ft-btn">
            <i className="ic-npa ic-npa-icon-footer-facebook"></i>
          </a>
          <a href="https://www.twitter.com/KBank_Live" target="_blank" className="nav-ft-btn">
            <i className="ic-npa ic-npa-icon-footer-twitter"></i>
          </a>
          <a href="https://www.youtube.com/user/KBANKLIVE" target="_blank" className="nav-ft-btn">
            <i className="ic-npa ic-npa-icon-footer-youtube"></i>
          </a>
          <a href="https://www.instagram.com/kbanklive/" target="_blank" className="nav-ft-btn">
            <i className="ic-npa ic-npa-icon-footer-ig"></i>
          </a>
        </div>
      </div>
    </div>
  );
};

export const HeaderWithSearch = (props) => {
  const [searchFilter] = useSelector((state) => [state.property.searchFilter]);

  return (
    <>
      <Header {...searchFilter} {...props} />
    </>
  );
};

const Header = React.memo((props) => {
  const searchFilter = props;

  const dispatch = useDispatch();

  useEffect(() => {
    getApiDataAsync({
      urlPath: "/RequestStations",
    })
      .then((data) => {
        var list = Array.from(data, (x) => {
          return {
            text: x.StationNameTH,
            value: x.StationID,
            title: x.PlaceType,
            location: { Latitude: x.Latitude, Longitude: x.Longitude },
          };
        });

        list = [...list].sort(function (a, b) {
          return a.text.localeCompare(b.text);
        });

        dispatch(searchListChange({ field: "station", value: list }));
      })
      .catch(function (error) {
        console.log(error);
        // alertErrorAsync(error);
      })
      .then(() => {
        dispatch(searchListChange({ field: "province", value: province }));
      });

    //Tagging
    PDT_Header();
  }, []);

  function OnSearchDataChange(payload) {
    commonSearchDataChange(dispatch, payload, searchFilter, searchDataChange, OnsearchListChange);
    // const field = payload.field;
    // if (field === "province") {
    //   const list = searchFilter[field].option.find(x => x.value == payload.value)

    //   OnsearchListChange({ field: "district", value: list.child })
    //   OnsearchListChange({ field: "subDistrict", value: [] })
    // } else if (field === "district") {
    //   const list = searchFilter[field].option.find(x => x.value == payload.value)

    //   OnsearchListChange({ field: "subDistrict", value: list.child })
    // }
    // dispatch(searchDataChange(payload))
  }

  function OnsearchListChange(payload) {
    dispatch(searchListChange(payload));
  }

  function OnInputChange(fieldName, value) {
    // const value = e.target.value
    dispatch(searchDataChange({ field: fieldName, value: value }));
  }

  function OnIonRangeDataChange(fieldName, from, to) {
    const payload = valueRangeMaxMin(fieldName, from, to);
    console.log(fieldName, payload.value);
    dispatch(searchIonRangeChange(payload));
  }

  function OnRangeInputDataChange(fieldName, from, to) {
    const payload = valueRangeMaxMin(fieldName, from, to);
    console.log(fieldName, payload.value);
    dispatch(searchIonRangeChange(payload));
    dispatch(updateIonRange({ fieldName }));
  }

  function OnRadioCheck(fieldName, value, group) {
    console.log(fieldName, value, group);
    dispatch(CheckBoxChange({ fieldName, value, group }));
  }

  function GoToSearch() {
    console.log("search", isExpand());

    var url = "";
    window.dataLayer = window.dataLayer || [];

    if (isExpand()) {
      url = gotoSearchPage(searchFilter);
      var search_text = searchFilter.keyword.value;

      var search_location = [
        searchFilter.province.value,
        searchFilter.district.value,
        searchFilter.subDistrict.value,
      ]
        .filter((x) => x)
        .join(",");

      var search_filter_1 = [
        searchFilter.propertyType.value,
        searchFilter.rangePrice.value,
        searchFilter.areaRange.value,
        searchFilter.useableAreaRange.value,
        searchFilter.bedroom.value,
        searchFilter.bathroom.value,
        searchFilter.station.value,
      ]
        .filter((x) => x)
        .join(",");

      var search_filter_2 = searchFilter.assetTypes.value;
      window.dataLayer.push({
        event: "submitSearch",
        eventCategory: "search",
        eventAction: "submit_filters_NPA",
        eventLabel: `ค้นหาทรัพย์มือสองทำเลดีทั่วไทย`, //`ค้นหาทรัพย์มือสองทำเลดีทั่วไทย_${url}`,   //หน้าที่ค้นหา
        dimension49: `${search_text}`, //คำค้นหา
        dimension7: `${search_location}`, //จังหวัด,อำเภอ,ตำบล
        dimension50: `${search_filter_1}`, //ประเภททรัพย์,ช่วงราคา,เนื้อที่,พื้นที่ใช้สอย,ห้องนอน,ห้องน้ำ,สถานีใกล้เคียง
        dimension51: `${search_filter_2}`, //ทรัพย์โปรโมชั่น,ทรัพย์ฝากขาย
      });
    } else {
      url = gotoSearchPage({ keyword: searchFilter.keyword.value });
      window.dataLayer.push({
        event: "submitSearch",
        eventCategory: "search",
        eventAction: "submit_filters_NPA",
        eventLabel: `ค้นหาทรัพย์มือสองทำเลดีทั่วไทย`, //`ค้นหาทรัพย์มือสองทำเลดีทั่วไทย_${url}`,   //หน้าที่ค้นหา
        dimension49: `${searchFilter.keyword.value}`, //คำค้นหา
        dimension7: "", //จังหวัด,อำเภอ,ตำบล
        dimension50: "", //ประเภททรัพย์,ช่วงราคา,เนื้อที่,พื้นที่ใช้สอย,ห้องนอน,ห้องน้ำ,สถานีใกล้เคียง
        dimension51: "", //ทรัพย์โปรโมชั่น,ทรัพย์ฝากขาย
      });
    }

    console.log(url);
    window.open(url, "_self");
  }

  function OnClearSearch() {
    console.log("Clear Filter");
    window.dataLayer.push({
      event: "track_event",
      event_category: "NPA-MAIN-2022",
      event_action: "event_click",
      event_label: "ล้างการค้นหา",
    });
    dispatch(ClearSearch());
  }

  function isExpand() {
    return (
      $("#more-filter-desktop").css("height") != "0px" || $("#more-filter-mobile").hasClass("show")
    );
  }

  console.log("Header Render");

  return (
    <>
      <header id="header">
        <div id="header-bg" className="header-bg">
          <HeaderNav searchBtn={props.searchBtn} noti={props.noti} />
          <div id="inner-header-placeholder"></div>
          {/* < DeskTopSearch hideDesktop={props.hideDesktop} {...searchFilter} searchDataChange={OnSearchDataChange} IonRangeDataChange={OnIonRangeDataChange} RangeInputDataChange={OnRangeInputDataChange} OnRadioCheck={OnRadioCheck} GoToSearch={GoToSearch} ClearSearch={OnClearSearch} OnInputChange={OnInputChange} /> */}
        </div>
        {/* <TabSearch hideDesktop={props.hideDesktop} /> */}
      </header>
      <MobileNav />
      <PopUpSearch
        {...searchFilter}
        searchDataChange={OnSearchDataChange}
        IonRangeDataChange={OnIonRangeDataChange}
        RangeInputDataChange={OnRangeInputDataChange}
        OnRadioCheck={OnRadioCheck}
        GoToSearch={GoToSearch}
        ClearSearch={OnClearSearch}
        OnInputChange={OnInputChange}
      />
      {/* <MobileSearch {...searchFilter} searchDataChange={OnSearchDataChange} IonRangeDataChange={OnIonRangeDataChange} RangeInputDataChange={OnRangeInputDataChange} OnRadioCheck={OnRadioCheck} GoToSearch={GoToSearch} ClearSearch={OnClearSearch} OnInputChange={OnInputChange} /> */}
    </>
  );
}, areEqualObjValue);

function PDT_Header() {
  window.dataLayer = window.dataLayer || [];
  //advance search filter
  document
    .querySelectorAll(".more-filter-btn.mobile,.more-filter-btn.desktop")
    .forEach(function (item) {
      item.addEventListener("click", function (e) {
        window.dataLayer.push({
          event: "track_event",
          event_category: "search_filter",
          event_action: "event_click",
          event_label: "เลือกวิธีการค้นหาขั้นสูง",
        });
      });
    });

  //clear advanced filter
  document
    .querySelectorAll("#more-filter-desktop > div > div.row.mt-3 > div > div > button.clear-data")
    .forEach(function (item) {
      item.addEventListener("click", function (e) {
        window.dataLayer.push({
          event: "track_event",
          event_category: "NPAhome2022",
          event_action: "event_click",
          event_label: "ล้างการค้นหา",
        });
      });
    });

  //correct filter tab content ถ้าไม่หน่วงเวลา ช่วงราคาจะไม่ขึ้น
  document.querySelectorAll("#property-tab-search .property-nav-wrap a").forEach(function (item) {
    item.addEventListener("click", function (e) {
      setTimeout(
        window.dataLayer.push({
          event: "track_event",
          event_category: "Tab_content",
          event_action: "click",
          event_label: e.target.innerText,
        }),
        3000
      );
    });
  });

  //correct property filter selected
  document
    .querySelectorAll(
      "#assets-type-tabs .swiper-slide a,#assets-type-tabs2 .swiper-slide a,#assets-type-tabs3 .swiper-slide a"
    )
    .forEach(function (item) {
      item.addEventListener("click", function (e) {
        window.dataLayer.push({
          event: "track_event",
          event_category: document.querySelector("#property-tab-search .nav-item .nav-link.active")
            .innerText,
          event_action: "click",
          event_label: e.target.innerText.replace(/\s/g, ""),
        });
      });
    });
}
